import { Box, Paper, Typography } from "@mui/material";
import React from "react";

const ToursCard = ({ img, title, text }) => {
   return (
      <Paper
         sx={{
            width: "240px", // Fixed card width
            borderRadius: "8px", // Slight border radius for rounded corners
            boxShadow: 2, // Subtle shadow for depth
            overflow: "hidden", // Hide any overflow (important for truncating)
            margin: "10px", // Add spacing between cards
         }}
      >
         {/* Image Section */}
         <Box
            sx={{
               width: "100%",
               height: 130,
               backgroundImage: `url(${img})`,
               backgroundSize: "cover", // Ensure the image covers the entire Box
               backgroundPosition: "center",
            }}
         ></Box>

         {/* Title Section */}
         <Typography
            sx={{
               fontWeight: "bold",
               fontSize: "16px",
               padding: "10px",
               whiteSpace: "nowrap", // Prevent wrapping
               overflow: "hidden", // Hide overflow
               textOverflow: "ellipsis", // Show ellipsis if text is too long
            }}
         >
            {title}
         </Typography>

         {/* Text Section */}
         <Typography
            sx={{
               fontSize: "14px",
               padding: "0 10px 10px", // Add padding to the bottom
               color: "text.secondary", // Lighter color for text
               display: "-webkit-box", // Enable multi-line truncation
               overflow: "hidden",
               WebkitBoxOrient: "vertical", // For multi-line truncation
               WebkitLineClamp: 4, // Limit text to 4 lines
               textAlign: "justify",
               textOverflow: "ellipsis", // Add ellipsis if text overflows
               height: "95px",
            }}
         >
            {text}
         </Typography>
      </Paper>
   );
};

export default ToursCard;
